/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("modalOverlay");
    const videoContainer = document.getElementById("videoContainer");
    const closeBtn = document.getElementById("closeVideoModal");
    const openButtons = document.querySelectorAll(".openVideoModal");

    function injectVideo() {
      videoContainer.innerHTML = `
        <video class="account-page-video-controls" autoplay controls playsinline>
          <source src="https://cdn.shopify.com/videos/c/o/v/07811d35f1af43f08175741190c35b8e.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      `;
      videoContainer.style.display = "grid";
    }

    function openModal(e) {
        if (e) {
          if (typeof e.preventDefault === 'function') e.preventDefault();
          if (typeof e.stopPropagation === 'function') e.stopPropagation();
        }
        injectVideo();
        modal.classList.add("active");
      }

      function closeModal() {
        modal.classList.remove("active");

        modal.addEventListener("transitionend", function (e) {
          if (e.target !== modal) return;
          videoContainer.innerHTML = "";
          videoContainer.style.display = "none";
        }, { once: true });

        const d = new Date();
        d.setTime(d.getTime() + (14 * 24 * 60 * 60 * 1000));
        document.cookie = "videoDismissed=true; expires=" + d.toUTCString() + "; path=/";
      }

    function hasDismissedVideo() {
      return document.cookie.split(";").some(cookie => cookie.trim().startsWith("videoDismissed="));
    }

    openButtons.forEach(a => {
        a.addEventListener("click", openModal);
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", closeModal);
    }

    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        closeModal();
      }
    });

    document.addEventListener("keyup", function (e) {
      if (e.key === "Escape") {
        closeModal();
      }
    });

    if (
      (window.location.pathname === "/account/login" ||
      window.location.pathname === "/account/register") &&
      !hasDismissedVideo()
    ) {
      openModal(new Event("manual"));
    }
  });
